import { TabbedItemPage } from './TabbedItemPage';

export const ConfigurationPage = () => <TabbedItemPage itemPath="/maintenance/configuration" />;
